// @flow

import Configs from "@Config";
import API from "./API";

export default class CardAPI {
    static getCards(userKey: string): Promise<any> {
        return API.get(
            `${Configs.orderApi}/user/me/paymentMethods`,
            null,
            null
        );
    }

    static getOrderPaymentSession(orderID: string): Promise<any> {
        return API.post(
            `${Configs.orderApiv2}/${orderID}/user/me/payment/drop-in/methods`,
            null,
            {
                channel: "web"
            }
        );
    }

    static disableCard(userKey: string, reference: string): Promise<any> {
        return API.put(`${Configs.orderApi}/user/me/disable`, null, reference);
    }

    static getOriginKey(): Promise<any> {
        return API.post(
            `${Configs.orderApi}/payment/drop-in/origin-key`,
            null,
            {
                origin_domain: window.location.origin
            }
        );
    }

    static getApplePaySession(url: string): Promise<any> {
        return API.post(`${Configs.orderApi}/payment/apple/session`, null, {
            validation_url: url,
            host: window.location.host
        });
    }

    static payOrder(orderID: string, user_id: string, data: any, googleRecaptchaResponse: string, skipReCaptcha: boolean): Promise<any> {
        let url = `${Configs.orderApiv2}/${orderID}/user/${user_id}/payment/drop-in/payments`;
        if (skipReCaptcha) {
            url += `?skipRecaptcha=true`;
        } else {
            url += `?captchaResponse=${googleRecaptchaResponse}`;
        }
        return API.post(
            url,
            null,
            {
                return_url: window.location.href.split("?")[0],
                origin: window.location.origin,
                payment_method: data.paymentMethod,
                browser_info: data.browserInfo,
                allow_3ds2: true,
                redirect_from_method: "GET",
                store_payment_method: data.storePaymentMethod
            }
        );
    }

    static provideDetails(orderID: string, data: any): Promise<any> {
        return API.post(
            `${Configs.orderApiv2}/${orderID}/user/me/payment/drop-in/payments/details`,
            null,
            data
        );
    }
}
